module.exports = __webpack_public_path__ + "static/media/02.1f6caf49.png";